import type { ReactNode } from 'react'
import { Mascot } from '../brand/Mascot'
import styles from './EmptyState.module.css'

interface EmptyStateProps {
  icon?: string
  /** Zeigt statt des Text-Icons unser Maskottchen — für besonders sichtbare Leerzustände
   * (404, Dashboard, Chat), nicht pauschal überall (z.B. in engen Dropdown-Kontexten wäre
   * es zu groß). Bewusst opt-in statt Default. */
  mascot?: boolean
  /** Größe des Maskottchens in Pixeln, für enge Kontexte (z.B. die Benachrichtigungs-
   * Dropdown) kleiner als der Standard. Nur relevant wenn `mascot` gesetzt ist. */
  mascotSize?: number
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ icon = '—', mascot, mascotSize = 64, title, description, action }: EmptyStateProps) {
  return (
    <div className={styles.wrap}>
      {mascot ? <Mascot size={mascotSize} className={styles.mascot} /> : <div className={styles.icon}>{icon}</div>}
      <div className={styles.title}>{title}</div>
      {description ? <div className={styles.description}>{description}</div> : null}
      {action}
    </div>
  )
}
